import { Link } from 'react-router-dom';

/**
 * Official AIAC Card logo. Use this component wherever the AIAC brand appears.
 * @param {{ size?: 'sm' | 'md' | 'lg', withText?: boolean, linkTo?: string | null }} props
 */
export default function Logo({ size = 'md', withText = false, linkTo = '/' }) {
  const heights = { sm: 'h-20', md: 'h-28', lg: 'h-40' };
  const heightClass = heights[size] || heights.md;
  const img = (
    <img
      src="/logo-aiac.png"
      alt="AIAC Card"
      className={`${heightClass} w-auto object-contain select-none`}
      draggable={false}
    />
  );
  const content = withText ? (
    <div className="flex items-center gap-2">{img}</div>
  ) : img;
  if (linkTo) {
    return (
      <Link to={linkTo} className="inline-flex items-center" aria-label="AIAC Card home">
        {content}
      </Link>
    );
  }
  return content;
}
